import { render, staticRenderFns } from "./liveDetail.vue?vue&type=template&id=46e45658&scoped=true&"
import script from "./liveDetail.vue?vue&type=script&lang=js&"
export * from "./liveDetail.vue?vue&type=script&lang=js&"
import style0 from "./liveDetail.vue?vue&type=style&index=0&id=46e45658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e45658",
  null
  
)

export default component.exports